import React, { useState, useRef, useEffect } from "react";
import { Box, Stack, Divider } from "@mui/material";
import CustomButton from "../components/CustomButton";
import { BrowserQRCodeReader } from '@zxing/library';
import { NotFoundException } from '@zxing/library'
import '../styles/ScanQRCode.css'
import TopBar from "../components/TopBar";
import PublicEventCard from "../components/PublicEventCard";

const API_URL = process.env.REACT_APP_API_URL


const InterCode = () => {
  const [eventCode, setEventCode] = useState("");
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const qrReader = useRef(new BrowserQRCodeReader());
  const videoRef = useRef(null);
  const stopDecodingRef = useRef(null);
  const currentDate = new Date().setHours(0,0,0,0);
  const [currentEventList, setCurrentEventList] = useState([]);



  const handleDecode = (result) => {
    if (result && result.text) {
      setEventCode(result.text);
    }
  };
  
  const openCamera = async () => {
    setIsCameraOpen(!isCameraOpen);
    if (!isCameraOpen) {
      try {
        if (videoRef.current) {
          const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
          videoRef.current.srcObject = stream;
  
          qrReader.current.decodeFromVideoDevice(null, videoRef.current, (result, err) => {
            if (result) {
              handleDecode(result);
            }
            if (err && !(err instanceof NotFoundException)) {
              console.error(err);
            }
          }).then(stopDecoding => {
            stopDecodingRef.current = stopDecoding;
          });
        }
      } catch (error) {
        setIsCameraOpen(false); 
        alert("Error accessing the camera.")
        console.error("Error accessing the camera:", error);
      }
    } else {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
        videoRef.current.srcObject = null;
      }
  
      if (stopDecodingRef.current) {
        stopDecodingRef.current();
        stopDecodingRef.current = null;
      }
    }
  };
  
  useEffect(() => {
    const showEvents = async () => {
      await fetch(`${API_URL}/firebase/get-current-events`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          currentDate: currentDate,
        })
      }).then((res) => res.json())
      .then((res) => {
        setCurrentEventList(res)
      })
    };
    showEvents();
  }, []);

  const handleJoinEvent = () => {
    if (eventCode.trim() !== "") {
      if (isValidUrl(eventCode)) {
        window.location.href = eventCode; // Redirect to the scanned QR code URL.
      }
    }
  };
  
  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  return (
    <Box className="max_container" sx = {{ marginTop: 8 }}>
      <TopBar user={"User"}/>
      <Divider sx={{ height: 50 }}/>
      <Stack spacing={2} className="my-6">
        <CustomButton 
          myFunction={openCamera}
          text={`${isCameraOpen ? "Close Camera" : "Scan QR Code"}`}
        />
        <div className={`content-wrapper ${isCameraOpen ? "show" : "hide"}`}>
          <video ref={videoRef} width="300" height="300" muted="muted" autoPlay style={{ margin: '0 auto', display: 'block' }}></video>
        </div>
        {eventCode && <CustomButton 
          myFunction={handleJoinEvent}
          text={"Join Event"}
        />}
      </Stack>
      <Divider color="gray"/>
      <Divider sx={{ height: 5 }}/>
      <h3 className="uppercase font-medium text-white mb-2">Current Events</h3>
      {currentEventList
        .filter((item) => {
          const eventActive = item.Active;
          return eventActive;
        })
        .sort((x, y) => {
          const dateX = new Date(x.Date);
          const dateY = new Date(y.Date);
          return dateY - dateX;
        })
        .map((item) => (
          <div key={item.id}>
            <PublicEventCard
              event={item}
              pastEvent={false}
              eventCreator={item.Creator}
            />
          </div>
        ))}
    </Box>
  );
};

export default InterCode;
